import { createAsyncThunk } from "@reduxjs/toolkit";
import { getAccessToken } from "@shared/api/getAccessToken";
import { API } from "../authSlice";

export const sendEmailLink = createAsyncThunk<any, any, { rejectValue: { message: string } }>(
    "auth/sendEmailLink",
    async (payload: any, thunkAPI) => {
        const TOKEN = getAccessToken();
        try {
            const response = await fetch(`${API}/v1/verification/email/first_step`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-Auth-token": TOKEN
                },
                body: JSON.stringify(payload)
            });

            let data = await response.json();

            if (response.status === 200) {
                return data;
            } else {
                throw new Error(data.message);
            }
        } catch (error: any) {
            return thunkAPI.rejectWithValue({ message: error.message });
        }
    }
);